// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { FaEye, FaEyeSlash } from 'react-icons/fa';
// import SummaryApi from '../common/SummaryApi';

// const ResetPassword = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
  
//   const [email, setEmail] = useState('');
//   const [otp, setOtp] = useState(['', '', '', '']);
//   const [newPassword, setNewPassword] = useState('');
//   const [confirmNewPassword, setConfirmNewPassword] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [resendLoading, setResendLoading] = useState(false);
//   const [resendTimer, setResendTimer] = useState(0);

//   const otpInputRefs = useRef([]);

//   // Get email from navigation state
//   useEffect(() => {
//     if (location.state?.email) {
//       setEmail(location.state.email);
//     } else {
//       toast.error('Email not found. Please try again.');
//       setTimeout(() => {
//         navigate('/forgot-password');
//       }, 2000);
//     }
//   }, [location.state, navigate]);

//   // Timer for resend OTP
//   useEffect(() => {
//     if (resendTimer > 0) {
//       const timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
//       return () => clearTimeout(timer);
//     }
//   }, [resendTimer]);

//   // Focus first OTP input on mount
//   useEffect(() => {
//     if (otpInputRefs.current[0]) {
//       otpInputRefs.current[0].focus();
//     }
//   }, []);

//   const handleOtpChange = (value, index) => {
//     // Allow only digits
//     if (value && !/^\d$/.test(value)) return;

//     const newOtp = [...otp];
//     newOtp[index] = value;
//     setOtp(newOtp);

//     // Auto-focus next input
//     if (value && index < 3) {
//       otpInputRefs.current[index + 1].focus();
//     }
//   };

//   const handleOtpPaste = (e, index) => {
//     e.preventDefault();
//     const pastedData = e.clipboardData.getData('text');
    
//     if (!/^\d+$/.test(pastedData)) {
//       toast.error('Please paste only numbers');
//       return;
//     }

//     const digits = pastedData.split('').slice(0, 4);
//     const newOtp = [...otp];
    
//     // Fill OTP boxes with pasted digits
//     digits.forEach((digit, i) => {
//       if (index + i < 4) {
//         newOtp[index + i] = digit;
//       }
//     });
    
//     setOtp(newOtp);
    
//     // Focus the next empty box or the last box
//     const nextEmptyIndex = newOtp.findIndex((digit, i) => i >= index && digit === '');
//     const focusIndex = nextEmptyIndex !== -1 ? nextEmptyIndex : Math.min(index + digits.length, 3);
    
//     if (otpInputRefs.current[focusIndex]) {
//       otpInputRefs.current[focusIndex].focus();
//     }
//   };

//   const handleOtpKeyDown = (e, index) => {
//     // Handle backspace
//     if (e.key === 'Backspace') {
//       if (!otp[index] && index > 0) {
//         otpInputRefs.current[index - 1].focus();
//         const newOtp = [...otp];
//         newOtp[index - 1] = '';
//         setOtp(newOtp);
//       } else if (otp[index]) {
//         const newOtp = [...otp];
//         newOtp[index] = '';
//         setOtp(newOtp);
//       }
//     }
    
//     // Handle arrow keys
//     if (e.key === 'ArrowLeft' && index > 0) {
//       otpInputRefs.current[index - 1].focus();
//     }
//     if (e.key === 'ArrowRight' && index < 3) {
//       otpInputRefs.current[index + 1].focus();
//     }
    
//     // Handle paste with Ctrl+V or Cmd+V
//     if ((e.ctrlKey || e.metaKey) && e.key === 'v') {
//       // The paste event will be handled by handleOtpPaste
//     }
//   };

//   // Handle paste on the whole OTP container
//   const handleContainerPaste = (e) => {
//     e.preventDefault();
//     const pastedData = e.clipboardData.getData('text').trim();
    
//     if (!/^\d+$/.test(pastedData)) {
//       toast.error('Please paste only numbers');
//       return;
//     }

//     const digits = pastedData.split('').slice(0, 4);
//     const newOtp = [...otp];
    
//     // Fill all OTP boxes starting from first
//     digits.forEach((digit, i) => {
//       newOtp[i] = digit;
//     });
    
//     setOtp(newOtp);
    
//     // Focus the next empty box or the last box
//     const nextEmptyIndex = newOtp.findIndex(digit => digit === '');
//     const focusIndex = nextEmptyIndex !== -1 ? nextEmptyIndex : Math.min(digits.length, 3);
    
//     if (otpInputRefs.current[focusIndex]) {
//       otpInputRefs.current[focusIndex].focus();
//     }
//   };

//   const handleResendOTP = async () => {
//     if (!email) {
//       toast.error('Email not found');
//       return;
//     }

//     if (resendTimer > 0) {
//       toast.info(`Please wait ${resendTimer} seconds before resending`);
//       return;
//     }

//     setResendLoading(true);
//     try {
//       await axios.post(SummaryApi.forgotPassword?.url || '/api/resend-otp', { 
//         email: email 
//       });
//       toast.success('OTP resent successfully! Check your email.');
//       setResendTimer(60);
      
//       setOtp(['', '', '', '']);
//       if (otpInputRefs.current[0]) {
//         otpInputRefs.current[0].focus();
//       }
//     } catch (err) {
//       const errorMessage = err.response?.data?.message || 'Failed to resend OTP. Please try again.';
//       toast.error(errorMessage);
//     } finally {
//       setResendLoading(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');

//     const otpString = otp.join('');

//     if (!email) {
//       setError('Email is required');
//       return;
//     }

//     if (!otpString) {
//       setError('OTP is required');
//       return;
//     }

//     if (otpString.length !== 4) {
//       setError('Please enter complete 4-digit OTP');
//       return;
//     }

//     if (!newPassword || !confirmNewPassword) {
//       setError('Both password fields are required');
//       return;
//     }

//     if (newPassword !== confirmNewPassword) {
//       setError('Passwords do not match');
//       return;
//     }

//     if (newPassword.length < 6) {
//       setError('Password must be at least 6 characters long');
//       return;
//     }

//     setLoading(true);
    
//     try {
//       await axios.post(SummaryApi.resetPassword.url, { 
//         email: email,
//         otp: otpString,
//         newPassword: newPassword
//       });
      
//       toast.success('Password reset successfully!');
//       setTimeout(() => {
//         navigate('/login');
//       }, 1500);
      
//     } catch (err) {
//       const errorMessage = err.response?.data?.message || 'Error resetting password. Please try again.';
//       setError(errorMessage);
//       toast.error(errorMessage);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (!email) {
//     return (
//       <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-purple-50">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
//           <p className="mt-4 text-gray-600">Loading...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 px-4">
//       <div className="bg-white shadow-lg rounded-xl overflow-hidden w-full max-w-md">
//         <div className="p-6 md:p-8">
//           <h1 className="text-2xl font-bold text-gray-800 mb-2 text-center">Reset Password</h1>
          
//           <form onSubmit={handleSubmit} className="space-y-6">
//             {/* Email Display Field */}
//             <div className="space-y-2">
//               <label className="block text-sm font-medium text-gray-700">
//                 Email Address
//               </label>
//               <div className="relative">
//                 <input
//                   type="email"
//                   value={email}
//                   readOnly
//                   className="w-full px-4 py-2 border rounded-md bg-gray-50 text-gray-700 cursor-not-allowed pr-24"
//                 />
//                 <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
//                   <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded">Verified</span>
//                 </div>
//               </div>
//             </div>

//             {/* OTP Input Section */}
//             <div className="space-y-2">
//               <div className="flex justify-between items-center">
//                 <label className="block text-sm font-medium text-gray-700">
//                   Enter OTP
//                 </label>
//                 <button
//                   type="button"
//                   onClick={handleResendOTP}
//                   disabled={resendLoading || resendTimer > 0}
//                   className="text-sm text-blue-600 hover:text-blue-800 disabled:text-gray-400 disabled:cursor-not-allowed"
//                 >
//                   {resendLoading ? 'Sending...' : 
//                    resendTimer > 0 ? `Resend in ${resendTimer}s` : 
//                    'Resend OTP'}
//                 </button>
//               </div>
              
//               {/* OTP Input Boxes */}
//               <div 
//                 className="flex justify-center gap-3 mb-4"
//                 onPaste={handleContainerPaste}
//               >
//                 {otp.map((digit, index) => (
//                   <input
//                     key={index}
//                     ref={(el) => (otpInputRefs.current[index] = el)}
//                     type="text"
//                     maxLength={1}
//                     value={digit}
//                     onChange={(e) => handleOtpChange(e.target.value, index)}
//                     onPaste={(e) => handleOtpPaste(e, index)}
//                     onKeyDown={(e) => handleOtpKeyDown(e, index)}
//                     onFocus={(e) => e.target.select()}
//                     className="w-12 h-12 text-center text-2xl font-bold text-gray-800 border-b-2 border-gray-400 focus:border-blue-600 focus:outline-none bg-transparent"
//                     disabled={loading}
//                     inputMode="numeric"
//                   />
//                 ))}
//               </div>
              
//               <div className="flex flex-col items-center gap-1">
//                 <p className="text-xs text-gray-500">
//                   Enter the 4-digit OTP sent to your email
//                 </p>
//               </div>
//             </div>

//             {/* Password Fields Section */}
//             <div className="space-y-4">
//               <div className="space-y-1 relative">
//                 <label htmlFor="password" className="block text-sm font-medium text-gray-700">
//                   New Password
//                 </label>
//                 <input
//                   type={showPassword ? 'text' : 'password'}
//                   id="password"
//                   value={newPassword}
//                   onChange={(e) => setNewPassword(e.target.value)}
//                   className="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                   placeholder="Enter new password (min. 6 characters)"
//                   disabled={loading}
//                   minLength="6"
//                 />
//                 <button
//                   type="button"
//                   onClick={() => setShowPassword(!showPassword)}
//                   className="absolute right-3 top-[38px] text-gray-500 hover:text-gray-700"
//                   disabled={loading}
//                 >
//                   {showPassword ? <FaEye /> : <FaEyeSlash />}
//                 </button>
//               </div>

//               <div className="space-y-1 relative">
//                 <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">
//                   Confirm Password
//                 </label>
//                 <input
//                   type={showConfirmPassword ? 'text' : 'password'}
//                   id="confirmPassword"
//                   value={confirmNewPassword}
//                   onChange={(e) => setConfirmNewPassword(e.target.value)}
//                   className="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                   placeholder="Confirm new password"
//                   disabled={loading}
//                   minLength="6"
//                 />
//                 <button
//                   type="button"
//                   onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//                   className="absolute right-3 top-[38px] text-gray-500 hover:text-gray-700"
//                   disabled={loading}
//                 >
//                   {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
//                 </button>
//               </div>
//             </div>

//             {error && (
//               <div className="p-3 bg-red-50 border border-red-200 rounded-md">
//                 <p className="text-sm text-red-600 text-center">{error}</p>
//               </div>
//             )}

//             <button
//               type="submit"
//               disabled={loading || otp.join('').length !== 4}
//               className={`w-full py-3 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors font-medium ${
//                 loading || otp.join('').length !== 4 ? 'opacity-70 cursor-not-allowed' : ''
//               }`}
//             >
//               {loading ? 'Resetting Password...' : 'Reset Password'}
//             </button>

//             <div className="text-center mt-4">
//               <button
//                 type="button"
//                 onClick={() => navigate('/login')}
//                 className="text-sm text-blue-600 hover:text-blue-800 hover:underline"
//               >
//                 Back to Login
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ResetPassword;

import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { toast } from "react-hot-toast";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import SummaryApi from '../common/SummaryApi';

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState(['', '', '', '']);
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [resendLoading, setResendLoading] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);

  const otpInputRefs = useRef([]);

  // Shared input classes from ForgotPassword
  const inputClasses = "block px-4 py-3 w-full text-sm text-gray-900 bg-blue-50 rounded-md border-2 border-blue-200 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer placeholder-transparent";
  const labelClasses = "absolute text-sm duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] left-3 bg-white px-2 text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-[-50%] peer-placeholder-shown:top-1/2 peer-placeholder-shown:bg-transparent peer-placeholder-shown:text-gray-500 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:bg-white peer-focus:px-2 peer-focus:text-blue-600";

  // Get email from navigation state
  useEffect(() => {
    if (location.state?.email) {
      setEmail(location.state.email);
    } else {
      toast.error('Email not found. Please try again.');
      setTimeout(() => {
        navigate('/forgot-password');
      }, 2000);
    }
  }, [location.state, navigate]);

  // Timer for resend OTP
  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [resendTimer]);

  // Focus first OTP input on mount
  useEffect(() => {
    if (otpInputRefs.current[0]) {
      otpInputRefs.current[0].focus();
    }
  }, []);

  const handleOtpChange = (value, index) => {
    if (value && !/^\d$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 3) {
      otpInputRefs.current[index + 1].focus();
    }
  };

  const handleOtpPaste = (e, index) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text');
    
    if (!/^\d+$/.test(pastedData)) {
      toast.error('Please paste only numbers');
      return;
    }

    const digits = pastedData.split('').slice(0, 4);
    const newOtp = [...otp];
    
    digits.forEach((digit, i) => {
      if (index + i < 4) {
        newOtp[index + i] = digit;
      }
    });
    
    setOtp(newOtp);
    
    const nextEmptyIndex = newOtp.findIndex((digit, i) => i >= index && digit === '');
    const focusIndex = nextEmptyIndex !== -1 ? nextEmptyIndex : Math.min(index + digits.length, 3);
    
    if (otpInputRefs.current[focusIndex]) {
      otpInputRefs.current[focusIndex].focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      if (!otp[index] && index > 0) {
        otpInputRefs.current[index - 1].focus();
        const newOtp = [...otp];
        newOtp[index - 1] = '';
        setOtp(newOtp);
      } else if (otp[index]) {
        const newOtp = [...otp];
        newOtp[index] = '';
        setOtp(newOtp);
      }
    }
    
    if (e.key === 'ArrowLeft' && index > 0) {
      otpInputRefs.current[index - 1].focus();
    }
    if (e.key === 'ArrowRight' && index < 3) {
      otpInputRefs.current[index + 1].focus();
    }
  };

  const handleContainerPaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').trim();
    
    if (!/^\d+$/.test(pastedData)) {
      toast.error('Please paste only numbers');
      return;
    }

    const digits = pastedData.split('').slice(0, 4);
    const newOtp = [...otp];
    
    digits.forEach((digit, i) => {
      newOtp[i] = digit;
    });
    
    setOtp(newOtp);
    
    const nextEmptyIndex = newOtp.findIndex(digit => digit === '');
    const focusIndex = nextEmptyIndex !== -1 ? nextEmptyIndex : Math.min(digits.length, 3);
    
    if (otpInputRefs.current[focusIndex]) {
      otpInputRefs.current[focusIndex].focus();
    }
  };

  const handleResendOTP = async () => {
    if (!email) {
      toast.error('Email not found');
      return;
    }

    if (resendTimer > 0) {
      toast.info(`Please wait ${resendTimer} seconds before resending`);
      return;
    }

    setResendLoading(true);
    try {
      await axios.post(SummaryApi.forgotPassword?.url || '/api/resend-otp', { 
        email: email 
      });
      toast.success('OTP resent successfully! Check your email.');
      setResendTimer(60);
      
      setOtp(['', '', '', '']);
      if (otpInputRefs.current[0]) {
        otpInputRefs.current[0].focus();
      }
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'Failed to resend OTP. Please try again.';
      toast.error(errorMessage);
    } finally {
      setResendLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const otpString = otp.join('');

    if (!email) {
      setError('Email is required');
      return;
    }

    if (!otpString) {
      setError('OTP is required');
      return;
    }

    if (otpString.length !== 4) {
      setError('Please enter complete 4-digit OTP');
      return;
    }

    if (!newPassword || !confirmNewPassword) {
      setError('Both password fields are required');
      return;
    }

    if (newPassword !== confirmNewPassword) {
      setError('Passwords do not match');
      return;
    }

    if (newPassword.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }

    setLoading(true);
    
    try {
      await axios.post(SummaryApi.resetPassword.url, { 
        email: email,
        otp: otpString,
        newPassword: newPassword
      });
      
      toast.success('Password reset successfully!');
      setTimeout(() => {
        navigate('/login');
      }, 1500);
      
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'Error resetting password. Please try again.';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  if (!email) {
    return (
      <div className="min-h-screen bg-[#bfdaf9] font-sans text-gray-800 flex flex-col items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#bfdaf9] font-sans text-gray-800 flex flex-col">
      <main className="flex-1 flex items-center justify-center p-4">
        {/* Card Container matching ForgotPassword */}
        <div className="bg-white w-full max-w-[500px] rounded-sm shadow-xl p-8 md:px-12 md:py-10 text-center relative">
          
          {/* Header */}
          <h2 className="text-2xl font-bold mb-2 text-black">
            Reset Password
          </h2>
          {/* <p className="text-xs text-gray-800 font-medium mb-8">
            Reset password for: <span className="text-blue-600">{email}</span>
          </p> */}

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            
            {/* Email Display Field (Read-only with floating label style) */}
            <div className="relative mb-6 text-left">
              <div className="relative">
                <input
                  type="email"
                  id="email"
                  className={`${inputClasses} cursor-not-allowed bg-gray-50`}
                  placeholder=" "
                  value={email}
                  readOnly
                />
                <label htmlFor="email" className={labelClasses}>
                  Email Address
                </label>
                <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                  <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded">Verified</span>
                </div>
              </div>
            </div>

            {/* OTP Input Section */}
            <div className="mb-6">
              <div className="flex justify-between items-center mb-3">
                <span className="text-sm text-gray-700 font-medium">Enter OTP</span>
                <button
                  type="button"
                  onClick={handleResendOTP}
                  disabled={resendLoading || resendTimer > 0}
                  className="text-sm text-blue-600 hover:text-blue-800 disabled:text-gray-400 disabled:cursor-not-allowed"
                >
                  {resendLoading ? 'Sending...' : 
                   resendTimer > 0 ? `Resend in ${resendTimer}s` : 
                   'Resend OTP'}
                </button>
              </div>
              
              {/* OTP Input Boxes */}
              <div 
                className="flex justify-center gap-4 mb-3"
                onPaste={handleContainerPaste}
              >
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    ref={(el) => (otpInputRefs.current[index] = el)}
                    type="text"
                    maxLength={1}
                    value={digit}
                    onChange={(e) => handleOtpChange(e.target.value, index)}
                    onPaste={(e) => handleOtpPaste(e, index)}
                    onKeyDown={(e) => handleOtpKeyDown(e, index)}
                    onFocus={(e) => e.target.select()}
                    className="w-12 h-12 text-center text-2xl font-bold text-gray-800 border-b-2 border-gray-400 focus:border-blue-600 focus:outline-none bg-transparent"
                    disabled={loading}
                    inputMode="numeric"
                  />
                ))}
              </div>
              
              <p className="text-xs text-gray-500 text-center">
                Enter the 4-digit OTP sent to your email
              </p>
            </div>

            {/* New Password Field with floating label */}
            <div className="relative mb-6 text-left">
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="newPassword"
                  className={inputClasses}
                  placeholder=" "
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  disabled={loading}
                  minLength="6"
                />
                <label htmlFor="newPassword" className={labelClasses}>
                  New Password
                </label>
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  disabled={loading}
                >
                  {showPassword ? <FaEye /> : <FaEyeSlash />}
                </button>
              </div>
            </div>

            {/* Confirm Password Field with floating label */}
            <div className="relative mb-6 text-left">
              <div className="relative">
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  id="confirmPassword"
                  className={inputClasses}
                  placeholder=" "
                  value={confirmNewPassword}
                  onChange={(e) => setConfirmNewPassword(e.target.value)}
                  disabled={loading}
                  minLength="6"
                />
                <label htmlFor="confirmPassword" className={labelClasses}>
                  Confirm Password
                </label>
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  disabled={loading}
                >
                  {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
                </button>
              </div>
            </div>

            {/* Error Display */}
            {error && (
              <div className="p-3 bg-red-50 border border-red-200 rounded-md mb-6">
                <p className="text-sm text-red-600 text-center">{error}</p>
              </div>
            )}

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading || otp.join('').length !== 4}
              className="w-full text-white bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-3 text-center mb-6 transition-colors flex items-center justify-center"
            >
              {loading ? 'Resetting Password...' : 'Reset Password'}
            </button>

            {/* Back to Login Link */}
            <div className="text-sm text-gray-500">
              Remember your password?{' '}
              <button
                onClick={() => navigate('/login')}
                className="text-blue-600 font-semibold underline inline-flex items-center"
              >
                Sign in
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
};

export default ResetPassword;